import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from '../context/LanguageContext';
import '../styles/CardFlipIntro.css';

const CardFlipIntro = ({ onComplete }) => {
  const { t } = useTranslation();
  const [isFlipped, setIsFlipped] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  const handleFlip = () => {
    if (isExiting) return;
    setIsFlipped(!isFlipped);
  };

  const handleContinue = (e) => {
    e.stopPropagation();
    setIsExiting(true);
    setTimeout(() => onComplete(), 600);
  };

  return (
    <AnimatePresence>
      {!isExiting && (
        <motion.div
          className="card-flip-intro"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Ambient particles */}
          <div className="card-flip-particles">
            {Array.from({ length: 6 }, (_, i) => (
              <motion.div
                key={i}
                className="card-ambient-particle"
                style={{
                  width: 3 + Math.random() * 5,
                  height: 3 + Math.random() * 5,
                }}
                initial={{
                  x: (Math.random() - 0.5) * 400,
                  y: (Math.random() - 0.5) * 500,
                  opacity: 0,
                }}
                animate={{
                  x: [(Math.random() - 0.5) * 400, (Math.random() - 0.5) * 400],
                  y: [(Math.random() - 0.5) * 500, (Math.random() - 0.5) * 500],
                  opacity: [0, 0.5, 0],
                }}
                transition={{
                  duration: 4 + Math.random() * 3,
                  delay: Math.random() * 2,
                  repeat: Infinity,
                  ease: 'easeInOut',
                }}
              />
            ))}
          </div>

          <div className="card-flip-container">
            <motion.div
              className="card-flip-wrapper"
              onClick={handleFlip}
              animate={{ rotateY: isFlipped ? 180 : 0 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            >
              {/* Front - Photo */}
              <div className="card-face card-front">
                <div className="card-photo-wrapper">
                  <img src="/images/image1.jpg" alt="Gergely and Amiker" />
                  <div className="card-photo-overlay" />
                </div>
                <div className="card-front-text">
                  <span className="card-initials">{t('envelope.cardText')}</span>
                  <div className="card-front-divider" />
                  <span className="card-save-date">{t('hero.saveTheDate')}</span>
                </div>
              </div>

              {/* Back - Invitation */}
              <div className="card-face card-back">
                <div className="card-back-content">
                  <span className="card-back-invited">{t('envelope.youreInvited')}</span>
                  <div className="card-back-divider" />
                  <div className="card-back-names">
                    <span className="card-back-bride">Amiker</span>
                    <span className="card-back-ampersand">&</span>
                    <span className="card-back-groom">Gergely</span>
                  </div>
                  <span className="card-back-date">{t('envelope.date')}</span>
                  <motion.button
                    className="card-continue-btn"
                    onClick={handleContinue}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {t('envelope.continue')}
                  </motion.button>
                </div>
              </div>
            </motion.div>

            {/* Prompt */}
            <motion.p
              className="card-flip-prompt"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
            >
              {t('envelope.flipPrompt')}
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CardFlipIntro;
